import React from 'react';

import styled from 'styled-components';

import CareTypeFilter from 'common/Filters/CareTypeFilter';
import CompetitorsFilter from 'common/Filters/CompetitorsFilter';
import ReviewSourceFilter from 'common/Filters/ReviewSourceFilter';
import { hasAnyCCRCCompetitor, isCommunityCCRC } from 'components/Community/utils';
import { usePublicationContext } from 'components/Publication/PublicationContext';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import CompareCommunitiesFilter from 'components/View/filters/CompareCommunitiesFilter/CompareCommunitiesFilter';
import CustomCommunityContractTypeFilter from 'components/View/filters/CustomCommunityContractTypeFilter';
import DataQuarterFilter from 'components/View/filters/DataQuarterFilter/DataQuarterFilter';
import { FeeType } from 'types/fees';

import CMASummaryContractsFilter from './filters/CMASummaryContractsFilter/CMASummaryContractsFilter';
import CMASummaryFeeLevelFilter from './filters/CMASummaryFeeLevelFilter';
import CMASummaryRoomComparisonTypeFilter from './filters/CMASummaryRoomComparisonTypeFilter';
import CMASummaryRoomTypeFilter from './filters/CMASummaryRoomTypeFilter';
import CMASummaryViewFilter from './filters/CMASummaryViewFilter';
import HeaderViewFiltersCompare from '../View/filters/HeaderViewFiltersCompare';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: start;
  gap: 5px;
`;

const CMASummaryFilters = () => {
  const { competitors, competitorId, community, viewFilters } = useCommunityViewContext();
  const { publication } = usePublicationContext();
  const hasMultipleCompetitors = Boolean(competitors && competitors.length > 1);
  const showCommunityOnlyFilters = !competitorId && hasMultipleCompetitors;
  const showCompareHeader = Boolean(competitorId) && (hasMultipleCompetitors || Boolean(publication?.hash));

  const competitorsFilterOptions =
    competitors?.map((item) => ({
      label: item.comunity_name,
      value: item.id,
      color: item.color,
    })) || [];

  return (
    <Container>
      <DataQuarterFilter />
      {showCommunityOnlyFilters && <CompareCommunitiesFilter />}
      <CMASummaryViewFilter />
      <CMASummaryRoomComparisonTypeFilter />
      <CareTypeFilter careTypes={viewFilters?.careTypes ?? []} />
      <CMASummaryRoomTypeFilter />
      <CMASummaryFeeLevelFilter type={FeeType.CARE_FEE} />
      <CMASummaryFeeLevelFilter type={FeeType.MEDICATION_FEE} />
      <ReviewSourceFilter reviewSources={viewFilters?.reviewSources} />
      {showCommunityOnlyFilters && (
        <CompetitorsFilter competitors={viewFilters?.competitors ?? []} options={competitorsFilterOptions} />
      )}
      {showCompareHeader && <HeaderViewFiltersCompare />}
      {isCommunityCCRC(community?.rental_types) && <CMASummaryContractsFilter />}
      {!isCommunityCCRC(community?.rental_types) && hasAnyCCRCCompetitor(competitors ?? []) && (
        <CustomCommunityContractTypeFilter />
      )}
    </Container>
  );
};

export default CMASummaryFilters;
